module.exports = __webpack_public_path__ + "images/product-icon-energy-saving-trust.444370.svg";